import { createProjectDefultData, IProjectData, projectStore } from "@droid/project-interface"
import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useRouter } from "next/router"
export const CreateProjectButton = () => {
    const {t} = useTranslation("droid-project/project/ui/components/content")
    const router = useRouter()
    async function onCreateProjectClick(){
        const project:IProjectData = createProjectDefultData()
        projectStore.addDraft(project)
        const path = `/project-editor?id=${project.id}`
        await router.prefetch(path)
        router.push(path)
    }
    return <span><Button data-id={"create-project-button.b79975b3-cc10-4e3e-bc05-478a98c925b5"} 
    data-typeof-create-project-id="create-project-btn-from-ui-components-create-project-button"
    id="typeof-create-project-id-create-project-btn-from-ui-components-create-project-button"
    onClick={onCreateProjectClick}>{t('content.create')}</Button></span>
}

